import { payoutCommissionApi } from 'src/store/api/payoutCommission/requestHandlers';
import { IGetPayoutCommission, IPayoutCommissionToggle } from 'src/store/api/payoutCommission/types';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getPayoutCommissions = createAsyncThunk(
  'payoutCommission/getPayoutCommissions',
  async (data: IGetPayoutCommission, { rejectWithValue }) => {
    try {
      const response = await payoutCommissionApi.getPayoutCommissions(data);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const getPayoutCommission = createAsyncThunk('payoutCommission/getPayoutCommission', async (commissionId: number, { rejectWithValue }) => {
  try {
    const response = await payoutCommissionApi.getPayoutCommission(commissionId);

    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const togglePayoutCommission = createAsyncThunk(
  'payoutCommission/togglePayoutCommission',
  async (props: { id: number; data: IPayoutCommissionToggle }, { rejectWithValue }) => {
    try {
      const { id, data } = props;
      const response = await payoutCommissionApi.togglePayoutCommission(id, data);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const payoutCommissionActions = {
  getPayoutCommission,
  togglePayoutCommission,
  getPayoutCommissions,
};
